import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { AuthProvider } from "./pages/auth/AuthContext";
import { Provider } from "react-redux";
import { legacy_createStore as createStore } from "redux";
import reducer from "./redux/reducers";

const store = createStore(reducer);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
